module.exports = __webpack_public_path__ + "img/fashion_63.d9f56abc.jpg";